export let trackingScrollMixinBlock = {
	initTrackingScroll: (self) => {
		self.$element = self.$element || $(self.element);
		self.$tplHeader = self.$tplHeader || $('.tpl-header');

		let trackingId = self.$element.data('trackingId');
		if(!_.isNil(trackingId) && trackingId !== '') {
			let $tracker = $('[data-pg][data-tracker="true"]');
			self.$tplScroller = self.$tplScroller || $('.tpl-scroller');

			if(!($tracker && $tracker.length > 0)) {
				console.error(`TrackingScrollMixinBlock::Error`, 'Please ensure that the "[data-pg][data-tracker="true"]" element exists.');
				return;
			}

			if(!(self.$tplScroller && self.$tplScroller.length > 0)) {
				console.error(`TrackingScrollMixinBlock::Error`, 'Please ensure that the ".tpl-main" element exists.');
				return;
			}

			let markAsComplete = () => {
				if(!self.$element.data('trackingComplete')) {
					$tracker.trigger('tracking.complete', { $element: self.$element, trackingId: trackingId });
					self.$element.data('trackingComplete', true);
				}
			};

			self.$tplScroller.on('scroll', _.throttle(() => {
				// If the bottom part of the element is above the bottom part of the tplScroller
				if(Math.ceil((self.$element.position().top + self.$element.outerHeight())) < self.$tplScroller.height()) {
					// Emit to the data-pg which contains data-tracker="true"
					markAsComplete();
				}
			}, 250));

			// Mark scrolling as complete if the scroller clientHeight is greater than the scrollHeight
			if(self.$tplScroller[0].clientHeight >= self.$tplScroller[0].scrollHeight) {
				markAsComplete();
			}
		}
	}
};
